import { lazy } from "react";
import { ArrowRight, Wand2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { openTool } from "./Nav";
import { LazyCanvas } from "@/components/three/LazyCanvas";

const CameraScene = lazy(() => import("@/components/three/CameraScene"));

const PromptCard = () => (
  <div data-testid="generator-prompt-card" className="panel p-4 sm:p-5 mt-8 max-w-md">
    <div className="flex items-center gap-2 eyebrow !text-[11px] mb-3"><Wand2 className="h-3.5 w-3.5 text-[#d5d9df]" /> Image Generator</div>
    <div className="flex gap-4">
      <img src="/images/gen-neon-highway.jpg" alt="Generated neon highway" className="h-20 w-28 sm:h-24 sm:w-36 rounded-lg object-cover ring-1 ring-white/10 shrink-0" />
      <div className="min-w-0">
        <div className="text-xs text-slate-400 mb-1">Prompt</div>
        <p className="text-sm text-slate-100 leading-snug">Empty wet city highway at night after rain, blue neon reflections, skyscrapers in the distance</p>
      </div>
    </div>
    <div className="mt-4 pt-4 border-t border-white/10 flex items-center justify-between text-xs text-slate-300">
      <span>16:9 · 1 credit</span>
      <span className="text-[#d5d9df] font-medium">Use as background →</span>
    </div>
  </div>
);

export const GeneratorSection = () => (
  <section id="tool-generator" data-testid="tool-generator-section" className="relative py-20 lg:py-28 overflow-hidden">
    <div className="absolute right-0 top-1/2 -translate-y-1/2 h-[600px] w-[600px] rounded-full bg-[#3b4049]/15 blur-[150px] pointer-events-none" />
    <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
      <Reveal className="lg:col-span-5">
        <div className="eyebrow mb-5 flex items-center gap-3">Image Generator <span className="badge-new">New</span></div>
        <h2 className="h-display chrome text-3xl sm:text-4xl lg:text-5xl">
          No photo?<br /><span className="text-[#d5d9df] [-webkit-text-fill-color:#d5d9df]">Make one.</span>
        </h2>
        <p className="mt-6 text-slate-300 text-base md:text-lg leading-relaxed max-w-md">
          Type the place you dream of, or upload a photo and say what to change. Use the picture as your background in Background Swap with one click.
        </p>
        <PromptCard />
        <button data-testid="tool-generator-cta" onClick={() => openTool("generate")} className="btn-solid px-6 py-4 mt-8">
          Try Image Generator <ArrowRight className="h-4 w-4" />
        </button>
      </Reveal>
      <div className="lg:col-span-7 relative h-[360px] sm:h-[480px] lg:h-[620px]">
        <LazyCanvas
          Scene={CameraScene}
          testId="generator-3d-orbit"
          className="absolute inset-0 -mx-5 sm:mx-0"
          fallback={<img src="/images/gen-blue-hour.jpg" alt="" className="h-full w-full object-cover rounded-2xl opacity-70" />}
        />
        <div className="absolute bottom-2 left-0 right-0 text-center text-xs text-slate-400">Every scene in orbit was made with the Image Generator or our worlds</div>
      </div>
    </div>
  </section>
);
